export default "__VITE_ASSET__WDhuhBIB__"